import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	communicationBridgesSectionHeading: {
		id: 'servicedesk-incident-management-settings.communication-bridges.communication-bridges-section-heading',
		defaultMessage: 'Communication preferences',
		description:
			'Heading of the settings section which controls project level communication preferences settings for JSM',
	},
	communicationBridgesSectionDescription: {
		id: 'servicedesk-incident-management-settings.communication-bridges.communication-bridges-section-description',
		defaultMessage:
			'Allow everyone involved in an incident to quickly start or join a conference call or chat.',
		description:
			'Description text explaining the overall purpose of the communication preferences settings card',
	},
	premiumLozenge: {
		id: 'servicedesk-incident-management-settings.communication-bridges.premium-lozenge',
		defaultMessage: 'Premium',
		description: 'Premium lozenge text',
	},
});
